import React from "react";
import { Route, Redirect } from "react-router-dom";

const ProtectedRoutes = ({ path, component: Component, render, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if ((localStorage.getItem("auth-token")===null) || localStorage.getItem("auth-token")==="null")
          return <Redirect to="/login" />;
        return Component ? <Component {...props} /> : render();
      }}
    />
  );
};

export default ProtectedRoutes;
